import { inject, Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { RecaptchaVerifier } from 'firebase/auth';

/**
 * Manages the lifecycle of a Firebase {@link RecaptchaVerifier} used by
 * phone-based MFA flows (enrollment and verification).
 *
 * Only one invisible reCAPTCHA instance is active at a time — calling
 * {@link initRecaptcha} tears down any previous verifier before creating
 * a new one, preventing duplicate widget errors.
 *
 * Consumed by `PhoneEnrolComponent` and `PhoneVerifyComponent`.
 */
@Injectable({ providedIn: 'root' })
export class MultifactorRecaptchaService {
  private _auth = inject(Auth);
  private _recaptchaVerifier: RecaptchaVerifier | undefined;

  initRecaptcha(containerId: string): RecaptchaVerifier {
    this.clearRecaptcha();
    this._recaptchaVerifier = new RecaptchaVerifier(this._auth, containerId, {
      size: 'invisible',
    });
    return this._recaptchaVerifier;
  }

  clearRecaptcha(): void {
    if (this._recaptchaVerifier) {
      this._recaptchaVerifier.clear();
      this._recaptchaVerifier = undefined;
    }
  }
}
